// @ts-nocheck
export function getter(key) {
  if (__SERVER__) return;

  if (!window || !window?.localStorage) return;
  try {
  } catch (err) {
    console.error(err); // ! should use logger
  }
  const val = localStorage.getItem(key);
  if (!val) {
    return;
  }

  return JSON.parse(localStorage.getItem(key));
}

export function setter(key, data) {
  if (__SERVER__) return;

  if (!window || !window?.localStorage) return;
  localStorage.setItem(key, JSON.stringify(data));
}
